import { render } from "./SelectWorkstation.vue?vue&type=template&id=445c6d24&scoped=true&ts=true"
import script from "./SelectWorkstation.vue?vue&type=script&lang=ts"
export * from "./SelectWorkstation.vue?vue&type=script&lang=ts"

import "./SelectWorkstation.vue?vue&type=style&index=0&id=445c6d24&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445c6d24"]])

export default __exports__